import React from "react";
import Styled from "./styles";
import TitleHeader from "../../EducationInfo/TitleHeader";
import Table from "../../Table";

const HealthPlans = ({ healthPlans = [], lastUpdatedDate, noDataMessage }) => {
  const columns = [
    { name: "networkPlanName", label: "Health Plan", width: "100" },
  ];

  let updatedDataMessage = noDataMessage;
  if (
    !(
      updatedDataMessage === "Profile under Development" ||
      updatedDataMessage === "Dr.'s survey not received"
    )
  ) {
    updatedDataMessage = "The physician did not supply this information";
  } else if (!updatedDataMessage) {
    updatedDataMessage = "None reported";
  }

  return (
    <Styled>
      <TitleHeader label="Health plans" lastUpdatedDate={lastUpdatedDate} />
      {healthPlans && healthPlans.length > 0 ? (
        <Table
          columns={columns}
          data={healthPlans.map((p) => {
            let networkPlanName = p.networkPlanName;
            if (!networkPlanName) {
              networkPlanName = updatedDataMessage;
            }
            let otherPlanText = p.otherPlanText;
            if (otherPlanText) {
              networkPlanName = otherPlanText;
            }

            return { ...p, networkPlanName: networkPlanName };
          })}
        />
      ) : (
        <p className="no-content">{updatedDataMessage}</p>
      )}
    </Styled>
  );
};

export default HealthPlans;
